type CryptoLike = {
  randomUUID?: () => string;
  getRandomValues?: (array: Uint32Array<ArrayBuffer>) => void;
};

export function createIdempotencyKey(source?: CryptoLike) {
  const activeSource =
    source ??
    (globalThis.crypto
      ? {
          randomUUID:
            typeof globalThis.crypto.randomUUID === 'function'
              ? () => globalThis.crypto.randomUUID()
              : undefined,
          getRandomValues: (array: Uint32Array<ArrayBuffer>) => {
            globalThis.crypto.getRandomValues(array);
          },
        }
      : undefined);

  if (typeof activeSource?.randomUUID === 'function') return activeSource.randomUUID();

  const bytes = new Uint32Array(4);
  if (typeof activeSource?.getRandomValues === 'function') {
    activeSource.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 0xffffffff);
    }
  }

  const random = Array.from(bytes, (value) => value.toString(16).padStart(8, '0')).join('');
  return `upload_${Date.now().toString(36)}_${random}`;
}
